import Component from './component';
import createComponentFactory from '../createComponent';
import Swiper from 'swiper/dist/js/swiper.js';
import contentFoldedList from './contentFoldedList';

class ContentEntry extends Component {
  constructor(element, context, options) {
    super(element, context, options);

    this.tab = element.querySelectorAll('.js-contentList__tab');
    this.container = element.querySelector('.js-contentList__container');

    this._currentSelected = null;

    this._tabContext = null;


    this._handleInitTab = this._handleInitTab.bind(this);
    this._handleTabClick = this._handleTabClick.bind(this);
    this._handleSlideChangeTransitionEnd = this._handleSlideChangeTransitionEnd.bind(this);
    this._handleCompleteLoadMore = this._handleCompleteLoadMore.bind(this);
  }

  _bindEvents() {

    for(let tab of this.tab) {
      tab.addEventListener('click', this._handleTabClick);
    }

    this._tabContext.on('slideChangeTransitionEnd', this._handleSlideChangeTransitionEnd);
    this.context.dispatcher.on('completeLoadMore', this._handleCompleteLoadMore);
  }

  _unbindEvents() {

    for(let tab of this.tab) {
      tab.removeEventListener('click', this._handleTabClick);
    }

    this._tabContext.off('slideChangeTransitionEnd', this._handleSlideChangeTransitionEnd);
    this.context.dispatcher.off('completeLoadMore', this._handleCompleteLoadMore);
  }

  _handleTabClick(evt) {
    const target = evt.currentTarget;


    if(this._currentSelected === target) {
      return;
    }

    target.setAttribute('data-selected', 'true');

    if(this._currentSelected) {
      this._currentSelected.removeAttribute('data-selected');
    }

    this._currentSelected = target;
  }

  _handleCompleteLoadMore() {
    this._tabContext.updateAutoHeight();
  }

  _handleInitTab() {


    requestAnimationFrame(() => {

      const slide = this._tabContext.slides[this._tabContext.activeIndex];
      const hash = slide.dataset.hash;

      const tabs = Array.prototype.slice.call(this.tab);

      const currentTabIndex = tabs.findIndex((tab) => {
        const a = tab.querySelector('a');
        const href = a.getAttribute('href');

        return `#${hash}` === href;
      });

     if(currentTabIndex > -1) {
       tabs[currentTabIndex].setAttribute('data-selected', 'true');
     }

     this._currentSelected = tabs[currentTabIndex];

    });
  }

  _handleSlideChangeTransitionEnd() {

  }

  didRegisterComponent() {

    this._tabContext = new Swiper(this.container, {
      effect: 'fade',
      allowTouchMove: false,
      autoHeight: true,
      fadeEffect: {
        crossFade: true
      },
      hashNavigation: {
        replaceState: true,
        watchState: true
      },
      on: {
        init: this._handleInitTab
      }
    });

    this.registerComponent('list', '.js-foldedList', contentFoldedList);
    this._bindEvents();
  }

  didUnregisterComponent() {
    this.unregisterComponent('list');
    this._unbindEvents();

  }
}

export default createComponentFactory(ContentEntry);



// WEBPACK FOOTER //
// ./src/js/app/component/contentEntry.js